module.exports = __webpack_public_path__ + "static/media/icon_delete2.9d2e59c6.svg";